module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "item-img-page",
    class: {
      'item-img-page-show': _vm.animationShow, 'item-img-page-hide': !_vm.animationShow
    },
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.close.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "code-img-container"
  }, [_c('img', {
    style: ({
      'top': _vm.imgTop + 'px'
    }),
    attrs: {
      "id": "barcode",
      "alt": ""
    },
    on: {
      "touchstart": _vm.touchstartImg,
      "touchmove": _vm.touchmoveImg,
      "touchend": _vm.touchendImg
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1e636afc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BarcodeImg.vue
// module id = 543
// module chunks = 1